const Plant = ({ width }) => {
    return (
        <div className={`plant-icon ${width} h-auto`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 263.32 258.27">
                <g
                    fill="none"
                    stroke="#404041"
                    strokeMiterlimit="10"
                    strokeWidth="17.23"
                >
                    <path d="M131.66 12.18c30.75 30.75 30.75 67.68 0 98.44-30.75-30.75-30.75-67.68 0-98.44zM254.71 86.01c0 46.13-27.7 73.83-73.83 73.83 0-46.13 27.7-73.83 73.83-73.83zM8.61 86.01c0 46.13 27.7 73.83 73.83 73.83 0-46.13-27.7-73.83-73.83-73.83z"></path>
                    <path d="M131.66 258.27L131.66 110.62"></path>
                    <path d="M180.88 159.84c0 27.18-22.04 49.22-49.22 49.22s-49.22-22.04-49.22-49.22"></path>
                </g>
            </svg>
        </div>
    )
}

export default Plant
